import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsInputHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Input;
    }
}

//# sourceMappingURL=IsInputHelper.js.map
